import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { Form as FormikForm } from 'formik';
import { CustomLuxonAdapter } from './CustomLuxonAdapter';
import { ErrorHandler } from './ErrorHandler';

export const Form: React.FC<React.HTMLAttributes<HTMLFormElement>> = ({
  children,
  ...restProps
}) => (
  <FormikForm
    {...restProps}
  >
    <ErrorHandler />

    <LocalizationProvider
      dateAdapter={CustomLuxonAdapter}
      localeText={{
        okButtonLabel: 'Save',
      }}
    >
      {children}
    </LocalizationProvider>
  </FormikForm>
);
